import { Box, Typography, Radio } from '@mui/material';
import Image from 'next/image';

const PaymentMethodSelector = ({ t, paymentMethods, selectedPayment, setSelectedPayment }: any) => (
  <Box display="flex" flexDirection="column" gap={2} mb={3}>
    {paymentMethods.map((method: any) => {
      const isSelected = selectedPayment === method.key;
      return (
        <Box
          key={method.key}
          onClick={() => !method.disabled && setSelectedPayment(method.key)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 2,
            border: '1px solid',
            borderColor: isSelected ? '#1976D2' : '#E0E0E0',
            borderRadius: 3,
            bgcolor: isSelected ? '#F0F7FF' : 'white',
            cursor: method.disabled ? 'not-allowed' : 'pointer',
            opacity: method.disabled ? 0.5 : 1,
            transition: 'all 0.2s',
            minHeight: 64,
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Radio
              checked={isSelected}
              sx={{
                p: 0,
                color: '#E0E0E0',
                '&.Mui-checked': {
                  color: '#1976D2',
                },
              }}
            />
            <Typography variant="body1" fontWeight={600} fontSize={16}>
              {t(method.label)}
            </Typography>
          </Box>
          {method.icon && (
            <Box display="flex" alignItems="center">
              <Image
                src={method.icon}
                alt={method.label}
                width={0}
                height={0}
                sizes="100vw"
                style={{
                  maxWidth: '80px',
                  width: 'auto',
                  height: '32px',
                  maxHeight: '32px',
                  objectFit: 'contain'
                }}
              />
            </Box>
          )}
        </Box>
      );
    })}
  </Box>
);

export default PaymentMethodSelector; 